import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege, hideGroups } from '../../../stores/auth/selectors';
import { groupOptions } from '../../../stores/groups/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { assignUsersGroups } from '../../../stores/users/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';
import MultiSelect from '../../common/MultiSelect';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];
    groups: Array<{ label: string, value: string }>;
    hideGroups?: boolean;

    assignUsersGroups: (usersIds: string[], groupIds: string[]) => void;
}
interface State {
    showModal: boolean;
    selection?: ValueType<{ label: string, value: string }> | null;
}

class AssignUsersGroupsAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            selection: [],
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hideGroups === false &&
            this.props.hasPrivilege(['ASSIGN_USER_GROUP', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="no-icon"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        {t('users.button.assignGroups')}
                    </DropdownItem>
                    <ConfirmModal
                        className="overflow-visible"
                        header={t('users.modal.assignGroups.header') as string}
                        confirmText={t('modal.assign') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.assign();
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        <p>{t('users.modal.assignGroups.text') as string}</p>
                        <Select className={"dropdown-select group-select"}
                            isMulti={true}
                            options={this.props.groups}
                            value={this.state.selection}
                            onChange={this.handleSelectChange}
                        />
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        this.setState({ selection: (val === null || val === undefined) ? [] : val });
    }

    private assign = () => {
        if (this.state.selection && Array.isArray(this.state.selection) && this.state.selection.length > 0) {
            this.props.assignUsersGroups(
                this.props.selected,
                this.state.selection.map((option) => option.value)
            );
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    groups: groupOptions(state),
    hasPrivilege: hasPrivilege(state),
    hideGroups: hideGroups(state),
    selected: selected(state, 'users'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    assignUsersGroups: (ids: string[], groupIds: string[]) =>
        dispatch(assignUsersGroups(ids, groupIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(AssignUsersGroupsAction));